import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NotificationMessage } from '../notifications.model';
import { ToastNotificationsModel } from './toast-notifications.model';

@Injectable({ providedIn: 'root' })
export class ToastNotificationsService {
  private model: ToastNotificationsModel = {
    items: [],
    moduleName: ''
  };

  public toasts = new BehaviorSubject<ToastNotificationsModel>(this.model);

  public init(moduleName: string): void {
    this.model.moduleName = moduleName;
  }

  public addNotification(message: NotificationMessage): void {
    this.model.items.unshift(message);
    this.toasts.next(this.model);

    setTimeout(() => {
      message.dismissed = false;
      this.toasts.next(this.model);
    }, 2000);

    setTimeout(() => this.dismiss(message), 4000);
  }

  public dismiss(message: NotificationMessage): void {
    message.dismissed = true;
    setTimeout(() => { this.model.items = this.model.items.filter(x => x !== message); }, 1000);
  }
}
